export default {
    PackDus1: 'pack_dus_1',
    PackDus2: 'pack_dus_2',
    VolTank: 'vol_tank',
    ipal: 'ipal',
};
